import { TwoFactorResponse } from "@sp-crm/core";
import { QueryClient } from "react-query";
import { Action, Dispatch } from "redux";
import * as browser from "../../util/browser";
import { push } from "../../util/history";
import { Actions, loadAll } from "../actions";

export interface LoginState {
    loggedIn: boolean;
    loginFailureMessage: string | null;
    loginInProgress: boolean;
    twoFactorData: TwoFactorResponse | null;
}

export function loginReducer(state: LoginState, action: Action): LoginState {
    if (!state || action.type === Actions[Actions.LOGOUT]) {
        state = {
            loggedIn: false,
            loginInProgress: false,
            loginFailureMessage: null,
            twoFactorData: null,
        };
    }

    if (action.type === Actions[Actions.LOGIN_START]) {
        state = {
            ...state,
            loginInProgress: true,
        };
    }
    if (action.type === Actions[Actions.LOGIN_FINISH]) {
        state = {
            ...state,
            loggedIn: true,
            loginFailureMessage: null,
        };
    }
    if (action.type === Actions[Actions.LOGIN_FAIL]) {
        const typed = action as { type: string; message: string };
        state = {
            ...state,
            loginFailureMessage: typed.message,
            loginInProgress: false,
        };
    }

    if (action.type === Actions[Actions.LOGIN_REQUIRES_2FA]) {
        const typed = action as {
            type: string;
            twoFactorData: TwoFactorResponse;
        };
        state = {
            ...state,
            twoFactorData: typed.twoFactorData,
            loginInProgress: false,
            loginFailureMessage: null,
        };
    }

    return state;
}

export interface LoginUserData {
    userRecord?: {
        signedEula?: Date | string;
        [key: string]: unknown;
    };
    [key: string]: unknown;
}

export function handleLoginCompletion(
    userData: LoginUserData,
    dispatch: Dispatch<Action>,
    queryClient: QueryClient,
): void {
    if (userData.userRecord && userData.userRecord.signedEula) {
        browser.handleLogin(userData as unknown as browser.ILoginResponse);
        dispatch({ type: Actions[Actions.LOGIN_FINISH], user: userData });
        loadAll(queryClient, dispatch);
        push("/");
    } else {
        dispatch({
            userPayload: userData,
            type: Actions[Actions.EULA_TRANSITION],
        });
        push("/license");
    }
}
